<template>
    <v-container>
        <v-layout mt-3>
            <v-flex xs12 sm6 offset-sm3>

                <v-list two-line subheader>
                    <template>
                    <div v-for="(item, index) in items" v-bind:key="item.value">
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-sub-title>
                                    {{item.title}}
                                </v-list-tile-sub-title>

                                <v-list-tile-title>
                                    {{item.value}}
                                </v-list-tile-title>

                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider :key="index" color:primary></v-divider>
                        </div>
                    </template>

                </v-list>

            </v-flex>
        </v-layout>

        <v-layout align-content-end v-if="!this.$store.getters.isUserActive">
            <v-flex xs12 sm6 offset-sm3 mt-3>
                Ihre Email Adresse ist noch nicht aktiviert. Sie erhielten bei
                Eröffnung des Kontos eine E-Mail mit einem Aktivierungslink. Klicken Sie auf
                nachfolgenden Link, um einen neue E-Mail zu erhalten.
                <br />
                <v-btn small color="info" v-on:click="uiEvent('sendActivationMail')">Aktivierungsmail erneut senden</v-btn>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
    const config = require("./../../classes/myConfig").config;
    const firebaseFirestore = require('../../myFirebase/firebaseFirestore.js');
    import { FirebaseTable } from './../table/FirebaseTable.js';

    export default {
        data() {
            return {

                items: [
                    { title: 'E-Mail', value: this.$store.state.currentUser.email },
                    { title: 'Technische Benutzer Id', value: this.$store.state.currentUser.uid },
                    { title: 'Konto erstellt am ', value: this.$store.state.currentUser.metadata.creationTime },
                    { title: 'Letzte Anmeldung ', value: this.$store.state.currentUser.metadata.lastSignInTime },
                ],



                snackbarText: "",
                snackbar: false,
                x: null,
                y: "top",
                mode: "",
                timeout: 6000,
                show: false,
                valid: false,
                email: config.getTestMail(),
                password: config.getTestPassword(),
                password1: config.getTestPassword(),

                rules: {
                    required: value => !!value || "Required",
                    min: value => !!value || value.length >= 6 || "Min 6 characters",
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || "Invalid e-mail.";
                    }
                }
            };
        },
        computed: {
            accountState() {
                let user = this.$store.state.currentUser;
                console.log("User" + user);
                if (user !== null)
                    return this.$store.state.currentUser.emailVerified
                        ? "Your account is active"
                        : "Your account is not yet activated.";
                else return "YSNT";
            }
        },

        methods: {
            uiEvent(event) {
                // console.log("uiEvent : " + event);
                // Process events, that do not need store call
                switch (event) {
                    case "cancel": // return to landing page
                        this.$router.push({ name: "Landing" });
                        return;
                }

                // Process events, that  need a  call
                this.$store
                    .dispatch({
                        type: event,
                        name: this.name,
                        email: this.email
                    })
                    .then(result => {
                        console.log("Store returned : " + result.code);
                        this.processStoreResult(event, result);
                    })
                    .catch(error => {
                        console.log("Action FAILED" + error);
                    });
            },

            processStoreResult(event, result) {
                console.log("processStoreResult : " + result);
                // Process events, that do not need store call
                let code = result.code;
                switch (event) {
                    case "sendActivationMail":
                        if (code > 0) {
                            this.$store.commit("setSnackbarText", "Mail gesendet");
                        } else {
                            this.$store.commit(
                                "setSnackbarText",
                                "Mail konnte nicht gesendet werden"
                            );
                        }
                        this.snackbar = true;
                        return;
                }
            }
        },


        async created() {
            let mail = this.$store.state.currentUser.email;
            
            let fbTable = new FirebaseTable()
            let entry = await fbTable.read_by_key('S4_M29_462',mail);
            if (entry) {
                this.items.push({
                    title: 'SAP S/4 Konto',
                    value: entry.account + " ("+ entry.timestamp.toDate()+") "
                })

            }
        },

        beforeCreate() {
            console.log("Checking user...");
            if (this.$store.state.currentUser == null) {
                console.log("Left Profile, since no user was set.");
                this.$router.push({ name: "Landing" });
            }
        },

        beforeUpdate() {
            console.log("Checking user...");
            if (this.$store.state.currentUser == null) {
                console.log("Left Profile, since no user was set.");
                this.$router.push({ name: "Landing" });
            }
        }
    };
</script>
